import React, { useEffect, useState } from "react";
import * as API from "../helpers/api";
import config from "../config";
import Loading from "react-loader-spinner";
import { useLang } from "../helpers/language";
import parse from "html-react-parser";

import moment from "moment";
import SocialButtons from "../components/social-buttons/SocialButtons";
import { Dictionary } from "../assets/js/contexts";
import "../assets/css/pages/blog-post.scss";
import BlogItem from "../components/blog-item/BlogItem";
import useWindowSize from "../assets/hooks/useWindowSize";
import { useParams } from "react-router-dom";

const BlogPost = ({ dictionary, slug }) => {
    // const { title, content, createdAt, path } = blog.find(
    // ({ path }) => path === slug
    // );
    let description = document.querySelector('[property="og:description"]');
    description.content = 'First Armenian Craft Beer';
    let title = document.querySelector('[property="og:title"]');
    title.content = 'Dargett Beer';
    const redmoreBtn = {
        en: 'Read More',
        ru: 'Читать далее',
        hy: 'Կարդալ ավելին'
    }
    const { width } = useWindowSize();
    // eslint-disable-next-line
    const [blog, setBlog] = useState(undefined);
    const [blogPost, setBlogPost] = useState(undefined);
    const [blogPostList, setBlogPostList] = useState(undefined);
    const { lang } = useLang();
    const [isBusy, setBusy] = useState(true);
    const [isRefresh, setRefresh] = useState(false);
    let id = useParams().id;
    const refresh = () => {
        setRefresh(true)
    }
    useEffect(() =>
    {
        window.scrollTo(0, 0);
        (async () => {
            let rowBlogPost = await API.get(config.api.blogPost, {
                _id: id
            }, {}, true);
            setBlogPost(rowBlogPost);
            let rowBlogPostList = await API.get(config.api.blogPost, {}, {}, true, 3);
            setBlogPostList(rowBlogPostList);

            let rowBlogs = await API.get(config.api.blogPost, {}, {
                index: 1
            }, {}, 3);
            setBlog(rowBlogs);
            setRefresh(false)
            setBusy(false);
            // eslint-disable-next-line
        })();
        // eslint-disable-next-line
    }, [isBusy, isRefresh]);
    if ((!isBusy, blogPost))

        return (
            <Dictionary.Provider value={dictionary}>
                <div id="blog-post">
                    {/* <Navigation 
                dark={true}
                lang={lang}/> */}

                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-8 d-flex justify-content-between title">
                                <h1> {
                                    blogPost[0].title[lang] ? blogPost[0].title[lang] : ""
                                } </h1>
                                <span className="date">{
                                    moment(blogPost[0].date).format("DD-MM-YYYY")
                                }</span>
                            </div>
                            <div className="col-md-8">
                                <hr />
                            </div>
                        </div>
                        <div className="row justify-content-center"
                            style={
                                { marginTop: 32 }
                            }>
                            <div className="col-md-10">
                                <img src={
                                    blogPost[0].uploads ? `${config.api.API_URL
                                        }/${blogPost[0].uploads[0]?.path
                                        }` : ""
                                }
                                    width="100%"
                                    alt="" />
                            </div>
                            <div className="col-md-8">
                                {
                                    blogPost[0].desc[lang] ? parse(blogPost[0].desc[lang]) : ""
                                } </div>
                            <div className="col-md-10 d-none d-sm-flex justify-content-center"
                                style={
                                    {
                                        marginTop: 42,
                                        marginBottom: 84
                                    }
                                }>
                                <SocialButtons />
                            </div>
                            <div className="col-12">
                                <div className="row align-items-center">
                                    <div className="col-md-4 col-3">
                                        <hr />
                                    </div>
                                    <div className="col-md-4 col-6">
                                        <h3>{
                                            redmoreBtn[lang]
                                        }</h3>
                                    </div>
                                    <div className="col-md-4 col-3">
                                        <hr />
                                    </div>
                                </div>
                                <div className="row similar"
                                    style={
                                        { marginTop: 65 }
                                    }>
                                    {
                                        blogPostList ? blogPostList.map((item, index) => (
                                            <div className="col-lg-4 col-md-6 col-sm-12"
                                                key={
                                                    `blog-item-${index}`
                                                }>
                                                <BlogItem index={index}
                                                    item={item}
                                                    windowWidth={width}
                                                    refresh={refresh} />
                                            </div>
                                        )) : null
                                    } </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dictionary.Provider>
        );
    else
        return <Loading type="Oval" color="#FFBE03" className="loader" />;



};

export default BlogPost;
